import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
import ReplyComposer from 'flarum/forum/components/ReplyComposer';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import Composer from 'flarum/forum/components/Composer';
import UploadImageModal from './components/UploadImageModal';
import Button from 'flarum/common/components/Button';
import Tooltip from 'flarum/common/components/Tooltip';

app.initializers.add('happydigital-mutluresim', () => {
  app.mutluresimImages = [];

  // Ortak buton ekleme fonksiyonu
  const addUploadButton = (items) => {
    const canUpload      = app.forum.attribute('mutluresimCanUpload');
    const dailyRemaining = app.forum.attribute('mutluresimDailyRemaining');

    // Yetkisiz kullanıcıya buton gösterme
    if (!canUpload) return;

    const limitReached = dailyRemaining === 0;
    const tooltipText  = limitReached
      ? 'Günlük yükleme sınırınıza ulaştınız'
      : dailyRemaining > 0
        ? `Resim Yükle (${dailyRemaining} hakkınız kaldı)`
        : 'Resim Yükle';

    items.add(
      'mutluresim-upload',
      <Tooltip text={tooltipText}>
        <Button
          className={`Button Button--icon Button--link${limitReached ? ' Mutluresim-btn--disabled' : ''}`}
          icon="fas fa-image"
          onclick={() => {
            if (limitReached) {
              app.alerts.show(
                { type: 'error', controls: [] },
                'Günlük resim yükleme sınırınıza ulaştınız. Yarın tekrar deneyin.'
              );
              return;
            }

            app.modal.show(UploadImageModal, {
              onUpload: (imageUrl) => {
                app.mutluresimImages.push(imageUrl);
                m.redraw();
              },
            });
          }}
        />
      </Tooltip>,
      100 // Listenin başında görünmesi için yüksek öncelik
    );
  };

  // 1) Eğer Markdown eklentisi yüklüyse (flarum/markdown), butonu onun kendi araç çubuğuna ekle
  const MarkdownToolbar = flarum.core.compat['flarum/markdown/components/MarkdownToolbar'];
  if (MarkdownToolbar) {
    extend(MarkdownToolbar.prototype, 'items', function (items) {
      // Markdown'ın kendi görsel ekleme butonunu gizle
      if (items.has('image')) items.remove('image');
      // Bizim butonu ekle
      addUploadButton(items);
    });
  }

  // 2) Standart metin editörü araç çubuğu (Markdown yoksa veya Flarum varsayılan butonları)
  extend(TextEditor.prototype, 'toolbarItems', function (items) {
    // Flarum'un/başka eklentilerin varsayılan görsel ve fof-upload butonlarını gizle
    if (items.has('image')) items.remove('image');
    if (items.has('fof-upload')) items.remove('fof-upload');

    // Eğer Markdown eklentisi aktif değilse, butonu ana araç çubuğuna ekle
    // (Markdown aktifse zaten yukarıda eklendiği için tekrar eklemeyiz)
    if (!MarkdownToolbar) {
      addUploadButton(items);
    }
  });

  // Metin editörünün altına thumbnail şeridi ekle
  extend(TextEditor.prototype, 'view', function (vdom) {
    if (!vdom || !vdom.children || !Array.isArray(vdom.children)) return;

    if (app.mutluresimImages && app.mutluresimImages.length > 0) {
      const thumbnails = (
        <div className="Mutluresim-thumbnailContainer">
          {app.mutluresimImages.map((imgUrl, index) => (
            <div className="Mutluresim-thumbnail">
              <img src={imgUrl} alt="Önizleme" />
              <Button
                className="Button Button--icon Mutluresim-removeBtn"
                icon="fas fa-times"
                onclick={(e) => {
                  e.preventDefault();
                  app.mutluresimImages.splice(index, 1);
                  m.redraw();
                }}
              />
            </div>
          ))}
        </div>
      );
      vdom.children.push(thumbnails);
    }
  });

  // Yanıt veya tartışma gönderilirken resimleri içeriğe ekle
  function appendImages(data) {
    if (app.mutluresimImages && app.mutluresimImages.length > 0) {
      const imagesText = app.mutluresimImages.join('\n\n');
      data.content = (data.content ? data.content + '\n\n' : '') + imagesText;
    }
  }

  extend(ReplyComposer.prototype, 'data', appendImages);
  extend(DiscussionComposer.prototype, 'data', appendImages);

  // Composer kapatılınca listeyi temizle
  extend(Composer.prototype, 'hide', function () {
    app.mutluresimImages = [];
  });
});
